<template>
    <v-col cols="12" sm="6" lg="6" :class="setClass()">
        <v-card class="background-2 round-card">
            <v-card-text class="pa-0">
                <div class="pa-4">Distribuzione Task</div>
            </v-card-text>                
            <div id="tasksdistribution" class="px-2 mb-2" ref="tasksdistribution" style="height: 472px">
            </div>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
                <v-row dense class="ma-0">
                    <v-col cols="6" class="pa-4">
                    <div class="flex-column">
                        <span class="display-3 margin-auto info--text font-weight-thin">{{ totalAdded }}</span>
                        <span class="margin-auto text-uppercase font-weight-light">Totali</span>
                    </div>
                    </v-col>
                    <v-col cols="6" class="pa-4" style="border-left: 1px solid rgba(0, 0, 0, 0.12)">
                    <div class="flex-column">
                        <span class="display-3 margin-auto amber--text font-weight-thin">{{ totalArchived }}</span>
                        <span class="margin-auto text-uppercase font-weight-light">Archiviati</span>
                    </div>
                    </v-col>
                </v-row>
            </v-card-text>                 
        </v-card>
    </v-col>
</template>

<script>

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import am4themes_material from '@amcharts/amcharts4/themes/material'

am4core.useTheme(am4themes_material)
am4core.useTheme(am4themes_animated)

    export default {
        name: 'tasks-distribution',
        props: {
            id: Number,
        },

        data() {
            return {
                chart: {},
                totalArchived: 0,
                totalAdded: 0,
            }
        },

        methods: {
            initialize() {
            this.axios.get('tasks-distribution/' + this.id).then(response => {
                if (this._isBeingDestroyed || this._isDestroyed) return
                if(!_.isEmpty(this.chart)) {
                    this.chart.dispose();
                }
                this.chart = am4core.create(this.$refs.tasksdistribution, am4charts.PieChart)
                this.chart.data = response.data.data.tasks
                this.totalArchived = response.data.data.archived
                this.totalAdded = response.data.data.total
                // Set inner radius
                this.chart.innerRadius = am4core.percent(50)
                this.chart.numberFormatter.numberFormat = "#.##";

                // Add and configure Series
                let pieSeries = this.chart.series.push(new am4charts.PieSeries())
                pieSeries.dataFields.value = 'count'
                pieSeries.dataFields.category = 'name'
                pieSeries.slices.template.tooltipText = "[font-size: 12px]{name}: {value.percent}% ({value})[/]"

                // This creates initial animation
                pieSeries.hiddenState.properties.opacity = 1
                pieSeries.hiddenState.properties.endAngle = -90
                pieSeries.hiddenState.properties.startAngle = -90

                pieSeries.labels.template.disabled = false
                pieSeries.ticks.template.disabled = false
                pieSeries.labels.template.text = "[font-size: 11px]{category}: {value.percent} %[/]";


                // Add a legend
                this.chart.legend = new am4charts.Legend();
                let markerTemplate = this.chart.legend.markers.template;
                markerTemplate.width = 15;
                markerTemplate.height = 15;
                this.chart.legend.labels.template.text = "[font-size: 11px]{name}:[/]";
                pieSeries.legendSettings.valueText = "[font-size: 11px]{value.percent} %[/]";

                //this.model = response.data.model
                this.$store.commit('endProgress')

                }, response => {
                    // error callback
                })                
            },

            setClass() {
                if(this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
                    return 'pa-0 pr-2'
                }
                if(this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md){
                    return 'pa-0 pl-0 pr-2'
                }
                if(this.$vuetify.breakpoint.xs) {
                    return 'pa-0'
                }
            },

        },
        
        mounted() {
            this.$eventBusUtility.$on('updatedTaskboard', () => {
                this.initialize()
            })
        },

        created() {
            this.initialize()
        },

        beforeDestroy() {
            if (this.chart && !_.isEmpty(this.chart)) {
                this.chart.dispose()
            }
			this.$eventBusUtility.$off('updatedTaskboard')
		},
    }
</script>